exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\np[data-v-e9ca2dd6] {\n  color: #989898;\n}\n", "", {"version":3,"sources":["/app/dms/prod/javaprojects/AgentPortaICOM/src/components/shared/src/components/shared/Footer.vue?2d77eee2"],"names":[],"mappings":";AAmBA;EACA,eAAA;CACA","file":"Footer.vue","sourcesContent":["<template>\n    <p class=\"qrp-text-muted\">&copy;{{ year }} QuinStreet Inc. All rights reserved.</p>\n</template>\n\n<script>\nexport default {\n  data() {\n    return {\n      year: null,\n    };\n  },\n  created() {\n    const date = new Date();\n    this.year = date.getFullYear();\n  },\n};\n</script>\n\n<style scoped>\np {\n  color: #989898;\n}\n</style>\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e9ca2dd6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/shared/Footer.vue
// module id = AKys
// module chunks = 2